(function () {
  if (window.__alLanding) return;
  window.__alLanding = 1;

  function initReveal() {
    var els = document.querySelectorAll('.reveal:not(.in)');
    if (!('IntersectionObserver' in window)) {
      els.forEach(function (e) { e.classList.add('in'); });
      return;
    }
    var io = new IntersectionObserver(function (entries) {
      entries.forEach(function (en) {
        if (en.isIntersecting) { en.target.classList.add('in'); io.unobserve(en.target); }
      });
    }, { threshold: 0.12, rootMargin: '0px 0px -8% 0px' });
    els.forEach(function (e) { io.observe(e); });
  }

  function initBA() {
    document.querySelectorAll('.al-ba').forEach(function (ba) {
      if (ba.dataset.init) return; ba.dataset.init = '1';
      var after = ba.querySelector('.al-ba__after');
      var handle = ba.querySelector('.al-ba__handle');
      function set(x) {
        var r = ba.getBoundingClientRect();
        var p = Math.max(0, Math.min(1, (x - r.left) / r.width));
        var pct = (p * 100).toFixed(2) + '%';
        after.style.width = pct; handle.style.left = pct;
      }
      var dragging = false;
      function down(e) { dragging = true; move(e); }
      function up() { dragging = false; }
      function move(e) { if (!dragging) return; var cx = e.touches ? e.touches[0].clientX : e.clientX; set(cx); }
      ba.addEventListener('mousedown', down); ba.addEventListener('touchstart', down, { passive: true });
      window.addEventListener('mousemove', move); window.addEventListener('touchmove', move, { passive: true });
      window.addEventListener('mouseup', up); window.addEventListener('touchend', up);
    });
  }

  function boot() { initReveal(); initBA(); }
  if (document.readyState !== 'loading') boot();
  else document.addEventListener('DOMContentLoaded', boot);
  document.addEventListener('shopify:section:load', boot);
})();
